export type InfluencerType = {
  blog: {
    title: string;
    url: string;
    rssFeed: string;
  };
  _id: string;
  userId: string;
  approval: "approve" | "reject" | "pending"; // Assuming these are possible statuses
  category: string[];
  bio: string;
  homeLocation: string;
  workLocation: string[];
  social: {
    type: string; // e.g., "instagram", "facebook", etc.
    id: string;
    url: string;
    followersCount: number;
    _id: string;
  }[];
  affiliateSharePercentage: number;
  firstName: string;
  lastName: string;
  avatar?: string;
  businessType: string; // e.g., "real", "digital", etc.
  createdAt: string; // ISO Date string
  updatedAt: string; // ISO Date string
  __v: number;
};

export type TimeSeriesData = {
  date: string; // ISO date string
  impression: number;
  profileView: number;
};

type ReferralStats = {
  referralSource: string; // e.g., "ali.com"
  visit: number;
  bookHotel: number;
  register: number;
  earning: number;
};

type ReferralTotal = {
  totalVisit: number;
  totalBookHotel: number;
  totalRegister: number;
  totalEarning: number;
};

export type InfluencerStats = {
  totalImpression: number;
  totalProfileView: number;
  timeSeries: TimeSeriesData[];
  referral: {
    stats: ReferralStats[];
    total: ReferralTotal[];
  };
};

export enum ReferralType {
  Visit = "visit",
  Register = "register",
  BookHotel = "bookHotel",
}
